const STRUCTURED_NOTES_PATTERN =
    /trackingNumber=([^,]+),\s*(?:orderSortingCode=[^,]+,\s*)?candidateBags=\[([^\]]*)]/s;

export interface BaggingScanNoMatchNotesParsed {
    trackingNumber: string;
    candidateBags: string;
}

export function parseBaggingScanNoMatchNotes(notes: string): BaggingScanNoMatchNotesParsed | null {
    const trimmed = notes.trim();
    if (!trimmed) {
        return null;
    }
    const match = STRUCTURED_NOTES_PATTERN.exec(trimmed);
    if (!match) {
        return null;
    }
    return {
        trackingNumber: match[1].trim(),
        candidateBags: match[2].trim(),
    };
}

/** 从 candidateBags 字符串中提取包牌号（忽略括号内 sortingCode/carrier 等元数据） */
export function splitCandidateBagsForDisplay(candidateBags: string): string[] {
    const trimmed = candidateBags.trim();
    if (!trimmed) {
        return [];
    }
    // 已格式化：仅包牌号，逗号分隔
    if (!trimmed.includes('(')) {
        return trimmed.split(/\s*,\s*/).map((s) => s.trim()).filter(Boolean);
    }
    // 原始格式：BAG001(LA-SAN-D,carrier=0), BAG002(...) — 不能按逗号拆，会切断括号内容
    const bagNumbers: string[] = [];
    const pattern = /([A-Za-z0-9]+)\(/g;
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(trimmed)) !== null) {
        bagNumbers.push(match[1]);
    }
    return bagNumbers;
}
